export enum PlanRulesTemplateApiUrls {
    CreatePlanRulesTemplate ='/api/PlanRulesTemplates/CreatePlanRulesTemplate',
    UpdatePlanRulesTemplate ='/api/PlanRulesTemplates/UpdatePlanRulesTemplate',
    GetPlanRulesTemplateByPlanId ='/api/PlanRulesTemplates/GetPlanRulesTemplateByPlanId?planId=',
}